import { useTranslation } from '@/i18n/useTranslation';

import { useAuth } from '@/auth/useAuth';
import { Link } from 'react-router-dom';
import { LanguageToggle } from './LanguageToggle';

export function Topbar() {
  const { displayValue, t } = useTranslation();
  const { currentUser, role, logout } = useAuth();

  return (
    <header className="app-topbar">
      <div className="flex-between" style={{ width: '100%' }}>
        <h1 className="visually-hidden">{t('Paint Defect Inspection Platform')}</h1>
        <div className="app-topbar__context">
          <span className="app-topbar__eyebrow">{t('SANWA KENKO')}</span>
          <span>{t('Quality assurance workspace')}</span>
        </div>
        <div className="cluster app-topbar__actions">
          {currentUser && (
            <div className="cluster" style={{ gap: 'var(--space-2)' }}>
              <span className="app-topbar__user">{currentUser.display_name}</span>
              {role && <span className="badge badge--neutral">{displayValue(role)}</span>}
            </div>
          )}
          <button type="button" className="btn btn--ghost btn--sm" onClick={logout}>
            {t('Sign out')}
          </button>
          <Link to="/profile" className="btn btn--ghost btn--sm">
            {t('My account')}
          </Link>
          <LanguageToggle />
        </div>
      </div>
    </header>
  );
}
